var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container1"},[_c('div',{staticClass:"swiper-wrapper commonBoder"},[_c('el-carousel',{attrs:{"interval":10000,"type":"card","indicator-position":"none"}},_vm._l((_vm.swiperList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.url,"alt":"","srcset":""}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }